/* eslint-disable import/no-dynamic-require */
import dayjs from 'dayjs';
// import loadRequire from './loadRequire';

// let promise;

export default function loadDayjs() {
  // if (promise) {
  //   return promise;
  // }
  // promise = loadRequire().then((require) => {
  // return new Promise((resolve) => {
  // require(['dayjs'], resolve);
  // });
  // });
  // return promise;
  // dayjs 在同步主包里已经有了，直接返回
  return Promise.resolve(dayjs);
}
